'use strict';

/**
 * Pict-Provider-CommentThreadAPI
 * ------------------------------
 * Browser-side CRUD client for the CommentThread entity, extending the generic EntityAPI provider.
 * Threads are owned polymorphically (OwnerType + IDOwner), the same shape as Media, so the one extra
 * helper is listForOwner: the threads attached to a given context (a Vision, a Work Item, ...).
 * Tenancy (IDCustomer) is enforced server-side, so the client never sends it.
 */

const libPictProviderEntityAPI = require('./Pict-Provider-EntityAPI.js');
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'CommentThreadAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/',
	EntityName: 'CommentThread',
	PluralRoute: 'CommentThreads',
	IDField: 'IDCommentThread'
};

class PictProviderCommentThreadAPI extends libPictProviderEntityAPI
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
	}

	/**
	 * The comment threads attached to a context.
	 * @param {string} pOwnerType - the entity kind ('Vision', 'WorkItem', ...)
	 * @param {number|string} pIDOwner - the entity id
	 * @returns {Promise<Array<object>>}
	 */
	listForOwner(pOwnerType, pIDOwner)
	{
		let tmpFilter = 'FBV~OwnerType~EQ~' + pOwnerType + '~FBV~IDOwner~EQ~' + pIDOwner;
		return libFrameworkClient.getJSON(this.fable, this._url(this.pluralRoute + '/FilteredTo/' + tmpFilter + '/0/250'))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [])
			.catch(() => []);
	}
}

module.exports = PictProviderCommentThreadAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;
